export default "__VITE_ASSET__10b27e79__"